import { Box, Checkbox, Divider, FormControlLabel, Paper, PaperProps } from '@mui/material';
import { createContext, useContext } from 'react';
import AddIcon from '@mui/icons-material/Add';

type Actions = {
  onNew?: () => void;
  newButtonLabel?: string;
  disabled?: boolean;
  selectAll?: { checked: boolean; disabled: boolean; onChange: () => void };
};

export const AutocompleteActionsContext = createContext<Actions>({});

// Slot identity never changes when selection, callbacks or button labels change.
export function AutocompleteActionsPaper({ children, ...props }: PaperProps) {
  const { onNew, newButtonLabel, disabled, selectAll } = useContext(AutocompleteActionsContext);
  return (
    <Paper {...props}>
      {selectAll && <>
        <Box onMouseDown={event => event.preventDefault()} pl={3} py={0.5}>
          <FormControlLabel
            label="Selecionar todos"
            disabled={disabled || selectAll.disabled}
            control={<Checkbox checked={selectAll.checked} onChange={selectAll.onChange} sx={{ marginRight: 1 }} />}
          />
        </Box>
        <Divider />
      </>}
      {children}
      {onNew && <>
        <Divider />
        <Box px={2} py={1} onMouseDown={event => event.preventDefault()}>
          <button
            type="button"
            disabled={disabled}
            onClick={onNew}
            className="text-sm text-primary-green flex flex-row items-center gap-1 font-semibold">
            <AddIcon sx={{ fontSize: 20 }} className="text-primary-green" />
            <span>{newButtonLabel ?? 'Novo'}</span>
          </button>
        </Box>
      </>}
    </Paper>
  );
}
